import { CheckIcon, HistoryIcon, XIcon } from "lucide-react";
import { OrderStatusConfigStore } from "@infrastructure/stores/orderStatusConfig.store";

export const getTextByOrderStatus = (status: string): string => {
  return OrderStatusConfigStore.getLabel(status);
};

export const getIconByOrderStatus = (status: string): React.ReactNode => {
  const icon = OrderStatusConfigStore.getIcon(status);
  switch (icon) {
    case "check":
      return <CheckIcon color="#fff" />;
    case "x":
      return <XIcon color="#fff" />;
    default:
      return <HistoryIcon color="#fff" />;
  }
};

